import ActionFrameNode from '../components/node/action-frame-node';
import { amazonNodes } from '../nodes/amazon';
import { anthologyNodes } from '../nodes/anthology';
import { blackboardNodes } from '../nodes/blackboard';
import { brightspaceNodes } from '../nodes/brightspace';
import { canvasNodes } from '../nodes/canvas';
import { colleagueNodes } from '../nodes/colleague';
import DeleteNode from '../nodes/commands/types/delete';
import ExecuteNode from '../nodes/commands/types/execute';
import InsertCommandNode from '../nodes/commands/types/insert';
import PrintNode from '../nodes/commands/types/print';
import PrintSchemaNode from '../nodes/commands/types/printSchema';
import RefreshNode from '../nodes/commands/types/refresh';
import SelectCommandNode from '../nodes/commands/types/select';
import SleepNode from '../nodes/commands/types/sleep';
import StopNode from '../nodes/commands/types/stop';
import StopIfZeroNode from '../nodes/commands/types/stop-if-zero';
import UpdateCommandNode from '../nodes/commands/types/update';
import ValidateNode from '../nodes/commands/types/validate';
import { CreateNode } from '../nodes/dataframes';
import InsertNode from '../nodes/dataframes/types/insert';
import SelectNode from '../nodes/dataframes/types/select';
import UpdateNode from '../nodes/dataframes/types/update';
import DefaultNode from '../nodes/default';
import { docuSignNodes } from '../nodes/docusign';
import { edReadyNodes } from '../nodes/edReady';
import { edfiNodes } from '../nodes/edfi';
import { elasticsearchNodes } from '../nodes/elasticsearch';
import { element451Nodes } from '../nodes/element451';
import { ethosNodes } from '../nodes/ethos';
import { formatNodes } from '../nodes/formats';
import { googleSpreadsheetNodes } from '../nodes/google';
import { graphqlNodes } from '../nodes/graphql';
import { httpNodes } from '../nodes/http';
import { infosilemNodes } from '../nodes/infosilem';
import { jdbcNodes } from '../nodes/jdbc';
import { jsonNodes } from '../nodes/json';
import { leadSquaredNodes } from '../nodes/leadSquared';
import { learningStreamNodes } from '../nodes/learningStream';
import { lingkNodes } from '../nodes/lingk';
import { localFileNodes } from '../nodes/localfile';
import { microsoftCosmosDbNodes } from '../nodes/microsoft';
import { moodleNodes } from '../nodes/moodle';
import { odataNodes } from '../nodes/odata';
import { paycomNodes } from '../nodes/paycom';
import { peoplesoftNodes } from '../nodes/peoplesoft';
import { salesForceNodes } from '../nodes/salesforce/';
import { sftpNodes } from '../nodes/sftp';
import { sqlNodes } from '../nodes/sql';
import DataOperationBatchNode from '../nodes/tasks/dataOperation/batch';
import DataOperationDedupNode from '../nodes/tasks/dataOperation/dedup';
import FileOperationAppendNode from '../nodes/tasks/fileOperation/append';
import FileOperationDeleteFileFromS3Node from '../nodes/tasks/fileOperation/deleteFileFromS3';
import FileOperationS3DirectoryListNode from '../nodes/tasks/fileOperation/s3DirectoryList';
import SftpOperationCopyFileNode from '../nodes/tasks/sftpOperation/copyFile';
import SftpOperationCopyFileToS3Node from '../nodes/tasks/sftpOperation/copyFileToS3';
import SftpOperationDeleteFileNode from '../nodes/tasks/sftpOperation/deleteFile';
import SftpOperationDirectoryListNode from '../nodes/tasks/sftpOperation/directoryList';
import SftpOperationMoveFileNode from '../nodes/tasks/sftpOperation/moveFile';
import { zoomNodes } from '../nodes/zoom';

const nodeTypesToComponentMapping = {
  // Action frames
  actionFrame: ActionFrameNode,
  // Connectors
  salesforceWriter: salesForceNodes.salesforceWriter,
  salesforceReader: salesForceNodes.salesforceReader,
  salesforceV2Reader: salesForceNodes.salesforceV2Reader,
  salesforceBulkWriter: salesForceNodes.salesforceBulkWriter,
  salesforceBulkReader: salesForceNodes.salesforceBulkReader,
  amazonRDSReader: amazonNodes.amazonRDSReader,
  amazonRDSWriter: amazonNodes.amazonRDSWriter,
  amazonRedshiftReader: amazonNodes.amazonRedshiftReader,
  amazonRedshiftWriter: amazonNodes.amazonRedshiftWriter,
  s3Reader: amazonNodes.s3Reader,
  s3Writer: amazonNodes.s3Writer,
  amazonSESConnector: amazonNodes.amazonSESConnector,
  awsElasticsearchReader5x: amazonNodes.awsElasticsearchReader5x,
  zoomReader: zoomNodes.zoomReader,
  zoomWriter: zoomNodes.zoomWriter,
  zoomGraphQLReader: zoomNodes.zoomGraphQLReader,
  json: jsonNodes.json,
  ethosReader: ethosNodes.ethosReader,
  ethosWriter: ethosNodes.ethosWriter,
  ethosV2AsyncReader: ethosNodes.ethosV2AsyncReader,
  ethosV2Reader: ethosNodes.ethosV2Reader,
  ethosGraphQLReader: ethosNodes.ethosGraphQLReader,
  httpReader: httpNodes.httpReader,
  httpWriter: httpNodes.httpWriter,
  httpV2Reader: httpNodes.httpV2Reader,
  sqlServer: sqlNodes.sqlServer,
  infosilemReader: infosilemNodes.infosilemReader,
  localFileReader: localFileNodes.localFileReader,
  localFileWriter: localFileNodes.localFileWriter,
  localFileImporter: localFileNodes.localFileImporter,
  graphqlReader: graphqlNodes.graphqlReader,
  sftpReader: sftpNodes.sftpReader,
  sftpWriter: sftpNodes.sftpWriter,
  lingkWriter: lingkNodes.lingkWriter,
  lingkAdapterReader: lingkNodes.lingkAdapterReader,
  lingkAdapterWriter: lingkNodes.lingkAdapterWriter,
  anthologyReader: anthologyNodes.anthologyReader,
  anthologyWriter: anthologyNodes.anthologyWriter,
  brightSpaceValenceApiReader: brightspaceNodes.brightSpaceValenceApiReader,
  brightSpaceValenceApiWriter: brightspaceNodes.brightSpaceValenceApiWriter,
  jdbcReader: jdbcNodes.jdbcReader,
  blackboardReader: blackboardNodes.blackboardReader,
  blackboardWriter: blackboardNodes.blackboardWriter,
  canvasReader: canvasNodes.canvasReader,
  canvasWriter: canvasNodes.canvasWriter,
  canvasGraphQLReader: canvasNodes.canvasGraphQLReader,
  colleagueReader: colleagueNodes.colleagueReader,
  colleagueWriter: colleagueNodes.colleagueWriter,
  microsoftCosmosDbReader: microsoftCosmosDbNodes.microsoftCosmosDbReader,
  microsoftCosmosDbV2Reader: microsoftCosmosDbNodes.microsoftCosmosDbV2Reader,
  docuSignReader: docuSignNodes.docuSignReader,
  edfiReader: edfiNodes.edfiReader,
  edfiWriter: edfiNodes.edfiWriter,
  edReadyReader: edReadyNodes.edReadyReader,
  element451Reader: element451Nodes.element451Reader,
  element451Writer: element451Nodes.element451Writer,
  googleSpreadsheetReader: googleSpreadsheetNodes.googleSpreadsheetReader,
  googleSpreadsheetWriter: googleSpreadsheetNodes.googleSpreadsheetWriter,
  googleBigQueryReader: googleSpreadsheetNodes.googleBigQueryReader,
  googleBigQueryWriter: googleSpreadsheetNodes.googleBigQueryWriter,
  leadSquaredReader: leadSquaredNodes.leadSquaredReader,
  leadSquaredWriter: leadSquaredNodes.leadSquaredWriter,
  learningStreamReader: learningStreamNodes.learningStreamReader,
  learningStreamWriter: learningStreamNodes.learningStreamWriter,
  moodleReader: moodleNodes.moodleReader,
  moodleWriter: moodleNodes.moodleWriter,
  paycomReader: paycomNodes.paycomReader,
  paycomWriter: paycomNodes.paycomWriter,
  peoplesoftReader: peoplesoftNodes.peoplesoftReader,
  peoplesoftWriter: peoplesoftNodes.peoplesoftWriter,
  logReader: elasticsearchNodes.logReader,
  oDataReader: odataNodes.oDataReader,
  // dataframes
  create: CreateNode,
  select: SelectNode,
  insert: InsertNode,
  update: UpdateNode,
  // commands
  printCommand: PrintNode,
  printSchemaCommand: PrintSchemaNode,
  refreshCommand: RefreshNode,
  sleepCommand: SleepNode,
  stopCommand: StopNode,
  stopifzeroCommand: StopIfZeroNode,
  validateCommand: ValidateNode,
  executeCommand: ExecuteNode,
  selectCommand: SelectCommandNode,
  insertCommand: InsertCommandNode,
  updateCommand: UpdateCommandNode,
  deleteCommand: DeleteNode,
  defaultCommand: DefaultNode,
  // formats
  excelReader: formatNodes.readformat.excel,
  excelWriter: formatNodes.writeformat.excel,
  jsonArrayWriter: formatNodes.writeformat.jsonArray,
  jsonReader: formatNodes.readformat.json,
  textReader: formatNodes.readformat.text,
  textWriter: formatNodes.writeformat.text,
  xmlReader: formatNodes.readformat.xml,
  xmlWriter: formatNodes.writeformat.xml,
  delimitedReader: formatNodes.readformat.delimited,
  delimitedWriter: formatNodes.writeformat.delimited,
  // Tasks
  sftpOperationdirectoryList: SftpOperationDirectoryListNode,
  sftpOperationdeleteFile: SftpOperationDeleteFileNode,
  sftpOperationcopyFile: SftpOperationCopyFileNode,
  sftpOperationcopyFileToS3: SftpOperationCopyFileToS3Node,
  sftpOperationmoveFile: SftpOperationMoveFileNode,
  fileOperationdeleteFileFromS3: FileOperationDeleteFileFromS3Node,
  fileOperations3DirectoryList: FileOperationS3DirectoryListNode,
  fileOperationappend: FileOperationAppendNode,
  dataOperationbatch: DataOperationBatchNode,
  dataOperationdedup: DataOperationDedupNode,
  httpXmlConnector: httpNodes.httpXmlConnector,
  jdbcWriter: jdbcNodes.jdbcWriter,
};

export default nodeTypesToComponentMapping;
